module.exports = __webpack_public_path__ + "img/animal_sounds.c1a650e4.jpg";